// Central content for the Johar Softech single-page site

export const CONTACT = {
  phone: "7050502020",
  phoneDisplay: "+91 70505 02020",
  email: "info@joharsoftech.in",
  website: "www.joharsoftech.in",
  whatsapp: "917050502020",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Industries", href: "#industries" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

export const HERO_KEYWORDS = ["Technology", "Outsourcing", "Healthcare", "BPO", "Consulting"];

export const WHY_CHOOSE_LIST = [
  "8+ Years Industry Experience",
  "Experienced Professionals",
  "Customized Business Solutions",
  "Cost Effective Operations",
  "Data Security",
  "Quick Project Deployment",
  "Dedicated Support",
  "Quality Assurance",
];

export const STATS = [
  { value: 8, suffix: "+", label: "Years Experience" },
  { value: 150, suffix: "+", label: "Projects Delivered" },
  { value: 50, suffix: "+", label: "Business Clients" },
  { value: 99, suffix: "%", label: "Client Satisfaction" },
  { value: 24, suffix: "×7", label: "Business Support", raw: "24" },
];

export const SERVICES = [
  {
    id: "bpo",
    icon: "Headset",
    title: "Business Process Outsourcing",
    tag: "BPO",
    desc: "End-to-end outsourcing services designed to improve efficiency, reduce costs and enhance customer satisfaction.",
    image: "https://images.pexels.com/photos/8204312/pexels-photo-8204312.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    items: [
      "Inbound Customer Support", "Outbound Calling", "Lead Generation", "Sales Support",
      "Technical Support", "Email Support", "Chat Support", "Back Office Operations",
      "Data Entry", "Customer Verification", "Document Processing", "Order Management",
      "Collections", "Helpdesk Services",
    ],
  },
  {
    id: "healthcare",
    icon: "HeartPulse",
    title: "Healthcare Outsourcing",
    tag: "Healthcare",
    desc: "Reliable healthcare process outsourcing services for hospitals, clinics and healthcare organizations.",
    image: "https://images.pexels.com/photos/5355850/pexels-photo-5355850.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    items: [
      "Medical Billing", "Medical Coding", "Revenue Cycle Management", "Insurance Verification",
      "Appointment Scheduling", "Medical Data Entry", "Claims Processing", "Denial Management",
      "AR Follow-up", "Healthcare Customer Support", "Provider Credentialing Support", "Healthcare Documentation",
    ],
  },
  {
    id: "it",
    icon: "Code2",
    title: "IT Services",
    tag: "Technology",
    desc: "Professional technology solutions to empower businesses and accelerate digital growth.",
    image: "https://images.pexels.com/photos/37730212/pexels-photo-37730212.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    items: [
      "Website Development", "Web Applications", "Software Development", "CRM Solutions",
      "Cloud Solutions", "API Integration", "Business Automation", "Technical Consulting",
      "Database Management", "Maintenance & Support",
    ],
  },
  {
    id: "rpo",
    icon: "Users",
    title: "Recruitment Process Outsourcing",
    tag: "RPO",
    desc: "Talent acquisition solutions for growing organizations across every function.",
    image: "https://images.pexels.com/photos/5324900/pexels-photo-5324900.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    items: [
      "Permanent Hiring", "Bulk Hiring", "Healthcare Recruitment", "IT Recruitment",
      "BPO Hiring", "Background Verification", "Payroll Assistance", "Interview Coordination",
    ],
  },
  {
    id: "consulting",
    icon: "LineChart",
    title: "Business Consulting",
    tag: "Strategy",
    desc: "Helping organizations optimize business performance and unlock sustainable growth.",
    image: "https://images.pexels.com/photos/33175650/pexels-photo-33175650.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    items: [
      "Business Strategy", "Operational Consulting", "Digital Transformation",
      "Market Research", "Process Optimization", "Business Planning", "Growth Consulting",
    ],
  },
  {
    id: "data",
    icon: "Database",
    title: "Data Management Services",
    tag: "Data",
    desc: "Accurate, secure and scalable data operations that keep your business running.",
    image: "https://images.unsplash.com/photo-1758518729685-f88df7890776?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    items: [
      "Data Entry", "Data Processing", "Data Validation", "Database Creation",
      "Document Digitization", "Excel Management", "CRM Management", "Quality Audits",
    ],
  },
];

export const INDUSTRIES = [
  { name: "Healthcare", icon: "Stethoscope" },
  { name: "Information Technology", icon: "Cpu" },
  { name: "Retail", icon: "ShoppingBag" },
  { name: "Banking", icon: "Landmark" },
  { name: "Insurance", icon: "ShieldCheck" },
  { name: "Telecommunications", icon: "Signal" },
  { name: "Education", icon: "GraduationCap" },
  { name: "Manufacturing", icon: "Factory" },
  { name: "Logistics", icon: "Truck" },
  { name: "E-commerce", icon: "ShoppingCart" },
  { name: "Government", icon: "Building2" },
  { name: "Startups", icon: "Rocket" },
];

export const WHY_BUSINESS = [
  { title: "Reliable Delivery", icon: "PackageCheck", desc: "On-time, every time — delivery you can plan around." },
  { title: "Experienced Team", icon: "Award", desc: "Seasoned professionals across every domain we serve." },
  { title: "High Accuracy", icon: "Target", desc: "Rigorous QA ensures precision at scale." },
  { title: "Affordable Solutions", icon: "Wallet", desc: "Enterprise quality at cost-effective pricing." },
  { title: "Scalable Operations", icon: "TrendingUp", desc: "Ramp up or down as your business demands." },
  { title: "Secure Infrastructure", icon: "Lock", desc: "Data security and compliance at the core." },
  { title: "Customer First Approach", icon: "Heart", desc: "Your success defines how we operate." },
  { title: "Continuous Improvement", icon: "RefreshCw", desc: "Always optimizing for better outcomes." },
];

export const PROCESS = [
  { step: "01", title: "Requirement Analysis", desc: "We deeply understand your goals, challenges and success metrics." },
  { step: "02", title: "Solution Planning", desc: "A tailored roadmap engineered around your operations." },
  { step: "03", title: "Project Execution", desc: "Expert teams deliver with precision and transparency." },
  { step: "04", title: "Quality Assurance", desc: "Multi-layer QA guarantees accuracy and reliability." },
  { step: "05", title: "Delivery", desc: "Seamless handover with measurable business outcomes." },
  { step: "06", title: "Continuous Support", desc: "Dedicated 24×7 support that scales with you." },
];

export const TESTIMONIALS = [
  {
    title: "Excellent Service",
    quote: "Johar Softech has consistently delivered quality outsourcing services with professionalism and efficiency.",
    author: "Operations Director",
    company: "Retail Enterprise",
  },
  {
    title: "Reliable Partner",
    quote: "Their healthcare outsourcing team significantly improved our operational efficiency.",
    author: "Practice Manager",
    company: "Healthcare Group",
  },
  {
    title: "Great Experience",
    quote: "Highly professional team with excellent customer support at every stage.",
    author: "Founder",
    company: "Technology Startup",
  },
];

export const FAQS = [
  {
    q: "What services does Johar Softech offer?",
    a: "We provide IT Services, Business Process Outsourcing (BPO), Healthcare Outsourcing, Recruitment Process Outsourcing, Business Consulting and Data Management Services — end-to-end.",
  },
  {
    q: "How experienced is your team?",
    a: "We bring 8+ years of industry experience with 150+ projects delivered for 50+ business clients across India and global markets.",
  },
  {
    q: "How do you ensure data security?",
    a: "We operate on secure infrastructure with strict access controls, compliance-driven processes and multi-layer quality audits to protect your data.",
  },
  {
    q: "Can you scale operations quickly?",
    a: "Yes. Our operations are built to scale — we can ramp teams up or down rapidly to match your business demand with quick project deployment.",
  },
  {
    q: "Do you provide 24×7 support?",
    a: "Absolutely. We offer dedicated 24×7 business support to keep your operations running without interruption.",
  },
];

export const SERVICE_OPTIONS = [
  "Business Process Outsourcing (BPO)",
  "Healthcare Outsourcing",
  "IT Services",
  "Recruitment Process Outsourcing",
  "Business Consulting",
  "Data Management",
  "Other",
];
